import { render } from "./IncidencesComponent.vue?vue&type=template&id=dfeae6ee"
import script from "./IncidencesComponent.vue?vue&type=script&lang=js"
export * from "./IncidencesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__